import React from "react";
import RichText from "components/rich-text";
import Image from "components/image";
import clsx from "clsx/lite";
import Video from "components/video";

const mediaWidth = {
	"small": "md:w-1/3",
	"medium": "md:w-1/2",
	"medium-large": "md:w-3/5",
	"large": "md:w-2/3",
};

const MediaWithText = ({ data }) => {
	const { mediaPosition, mediaType, text, bgColor, mediaBelowText = false, enableImageUrl, video, restrictImageHeight } = data;
	const textWidth = {
		"small": "md:w-2/3",
		"medium": "md:w-1/2",
		"medium-large": "md:w-2/5",
		"large": "md:w-1/3",
	}[data.mediaWidth] || "md:w-1/2";

	const hasBgColor = bgColor?.hex || false;

	return (
		<div className={clsx(
			"flex h-full",
			mediaBelowText ? "flex-col-reverse" : "flex-col",
			mediaPosition === "right" ? "md:flex-row-reverse" : "md:flex-row",
			hasBgColor ? "items-stretch" : "gap-4 md:gap-10 items-center"
		)}>
			<div className={
				clsx(
					"w-full",
					mediaWidth[data.mediaWidth] || "md:w-1/2",
					hasBgColor && "flex items-stretch max-h-160 my-auto",
					restrictImageHeight && "h-40 md:h-96",
				)}>
				{mediaType === "video" && video ? (
					<div className={clsx("relative", video.disableVideoAspectRatio
						? "w-full max-w-[656px] sm:aspect-[656/362] aspect-[3/2]  xxl:mx-5" : "aspect-video")}>
						<Video data={video} />
					</div>
				) : (
					enableImageUrl ?
						<Image image={data.costumImage} className="w-full inset-0 h-auto object-cover" />
						: <Image image={data.image} className="w-full h-auto object-cover" />

				)}
			</div>
			<div
				style={{ backgroundColor: bgColor?.hex }}
				className={clsx("size-full sm:w-full sm:h-auto",
					textWidth, hasBgColor && "py-10 px-6 md:p-16 flex flex-col justify-center")}
			>
				{text && <RichText data={{ content: text }} />}
			</div>

		</div>
	);
};

export default MediaWithText;
